import { START, SUCCESS, FAIL } from '../constants';
import { generateParticipantPitch, postParticipantPitch } from './actions';

export const generateLineUp = () => next => action => {
    const { generateLineUp, type, ...rest } = action;

    if (!generateLineUp) return next(action);

    next({ ...rest, type });
    next({ ...rest, type: generateParticipantPitch().type });
    return next({ ...rest, ...postParticipantPitch() });
};

export const postLineUp = store => next => action => {
    const { postLineUp, type, ...rest } = action;

    if (!postLineUp) return next(action);

    if (type === postParticipantPitch().type && store.getState().makerToolPage.idLineUp !== 0) {
        next({ type: type + START });

        fetch('http://ss2.si-ab.com/admin/keyval', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                appName: 'maker-tool',
                key: `${store.getState().makerToolPage.idLineUp}`,
                value: JSON.stringify({
                    type: store.getState().makerToolPage.lineupType,
                    players: store.getState().makerToolPage.customPitchLineupList
                })
            })
        })
            .then(res => {
                if (res.status === 200) {
                    return next({ ...rest, type: type + SUCCESS, res });
                }

                throw new Error(`Error load status ${status}`);
            })
            .catch(error => {
                console.error(error);
                return next({ ...rest, type: type + FAIL, error });
            });
    } else {
        return next(action);
    }
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/middlewares.js
 **/